import * as S from "./styles";
import Fontes from './fonts/Fontes.js';
import Pix from './assets/pix.png';

function SolicitarJanela({ coords, valores, pagamentoEscolhido, destino, origem, cliente, onClick }) {

  return (
    <S.BottomSheet>
            <S.DetailLittleBox>
              <p>Cliente: {cliente.nome}</p>
              <p>Telefone: {cliente.telefone}</p>
              <p>Email: {cliente.email}</p>

            </S.DetailLittleBox>
            {!!valores && !!valores.valores && valores.valores.filter(item => item.pagamentos[0].id === pagamentoEscolhido).map((item, index) => (
<S.VehicleCard key={index}><S.VehicleCardItem><S.BoxTipo color={!!item.legenda_cor_primaria ? item.legenda_cor_primaria : 'black'} >
<Fontes.IconFont
            icone={!!item.icone ? item.icone : "FontAwesome:car"}
            size={32}
            color={!!item.legenda_cor_secundaria ? item.legenda_cor_secundaria : 'white'}
          /></S.BoxTipo></S.VehicleCardItem>

              <S.VehicleCardItemG>
              <S.Texto3>{item.legenda_descricao}</S.Texto3>
              <S.Texto2>{item.legenda_explicacao}</S.Texto2></S.VehicleCardItemG>
              <S.VehicleCardItem>
              {item.pagamentos.map((pag, idx) => (
                <S.Texto4 key={idx}>R$ {pag.valor_final.toFixed(2)}</S.Texto4>
              ))}</S.VehicleCardItem>
            </S.VehicleCard>
            ))}

          <S.DetailLittleBox>
            {!!valores && !!valores.valores && valores.valores.filter(item => item.pagamentos[0].id === pagamentoEscolhido).map((item, index) => (
              <S.PagamentoCard key={index}>
                <S.PagamentoCardItem><S.Texto3>Forma de pagamento Pix no carro</S.Texto3>
                </S.PagamentoCardItem>
                <S.PagamentoCardItem>
                <img 
          src={Pix} 
          height={32}
          width={90}
          alt="Carregando..." 
        /></S.PagamentoCardItem></S.PagamentoCard>
            ))}
          </S.DetailLittleBox>
          <S.PrimaryButton
            onClick={() => {
                onClick();
            }}>
            Solicitar Corrida
          </S.PrimaryButton>
        </S.BottomSheet>
  );
}
export default SolicitarJanela;
